import { INDEX_SELECTED_BLOCKS_ELEMENT } from 'constants/MeshbotConstant';

/**
 * Extracts fields array from meshbot blocks
 * Retrieves the fields from the first element (INDEX_SELECTED_BLOCKS_ELEMENT) in the blocks array
 * @param {Array<Object>} blocks - Array of meshbot block objects
 * @returns {Array<Object>|undefined} Array of field objects if found, undefined otherwise
 * @example
 * const blocks = [
 *   {
 *     fields: [
 *       { name: 'time_node', type: '24_hours_time_array', value: [...] },
 *       { name: 'date_node', type: 'date', value: '2025-11-14' }
 *     ]
 *   }
 * ];
 * extractFields(blocks)
 * // returns [{ name: 'time_node', ... }, { name: 'date_node', ... }]
 *
 * @example
 * extractFields([]) // returns undefined
 * extractFields(null) // returns undefined
 */
export const extractFields = (blocks) => blocks?.[INDEX_SELECTED_BLOCKS_ELEMENT]?.fields;
